import { getAuxValueTranslationsByAuxValueId } from 'RestAPIs/AuxiliaryValues';

import useResource from 'components/shared/hooks/useResource';

const useGetAuxTranslationsByAuxValueId = (auxValueId?: number | string) => {
  'use memo';

  const { resource } = useResource({
    fetcher: () => {
      // Narrowed here rather than asserted non-null: `shouldFetch` below keeps the fetcher
      // from ever running without an id, and this keeps that guarantee inside the type system
      // instead of in the invisible coupling between the two lines.
      //
      // Rejected rather than thrown: `useResource` only catches rejections, so a synchronous
      // throw would escape the effect entirely instead of reaching its error handling.
      if (!auxValueId) {
        return Promise.reject(
          new Error('useGetAuxTranslationsByAuxValueId: no auxValueId')
        );
      }

      return getAuxValueTranslationsByAuxValueId(auxValueId);
    },
    shouldFetch: !!auxValueId
  });

  return resource;
};

export default useGetAuxTranslationsByAuxValueId;
